module.exports = __webpack_public_path__ + "static/media/8OLA5.9a58a1f9.jpg";